function getTrackingQueueNames() {
  return {
    // uncomment packages/tracking-worker/workers/index.js if you uncomment below line(TEST)
    // TEST: 'test', // this is to debug the queue issues in future.
    LOCATION_PUSH_INTUGINE: 'locationPushIntugine',
    GEO_FENCE_PUSH_INTUGINE: 'geoFencePushIntugine',
    ETA_PUSH_INTUGINE: 'etaPushIntugine',
    ERP_LOCATION_UPDATE: 'erpLocationUpdate',
    ERP_GEO_FENCE_UPDATE: 'erpGeoFenceUpdate',
    ERP_ETA_UPDATE: 'erpEtaUpdate',
    ERP_TRIP_CREATION_UPDATE: 'erpTripCreationUpdate',
    GET_CONSENT: 'getConsent',
    SHIPPER_UPDATE: 'shipperUpdate',
    CRON_PULL: 'cronPull',
    CALCULATE_DISTANCE_TRAVELLED: 'calculateDistanceTravelled',
    GENERIC_JOB_EXECUTOR: 'genericJobExecutor', // this type queue created to avoid opening
    // multiple redis connections since redis opens 3 connections per queue.
    GENERIC_REPORT_JOB_EXECUTOR: 'genericReportJobExecutor', // this type queue created to avoid
    // opening
    // multiple redis connections since redis opens 3 connections per queue.
  };
}

function getGenericJobTypes() {
  return {
    ETA_AND_GEO_FENCE_CALCULATION: 'ETA_AND_GEO_FENCE_CALCULATION',
    APP_LOCATION_PUSH: 'APP_LOCATION_PUSH',
    HYPERTRACK_LOCATION_SUMMARY: 'HYPERTRACK_LOCATION_SUMMARY',
    TRACKING_NOTIFICATION_WORKER: 'TRACKING_NOTIFICATION_WORKER',
  };
}

function getGenericReportJobTypes() {
  return {
    TRIP_STATUS_REPORT: 'TRIP_STATUS_REPORT',
  };
}

function shipperUpdateType() {
  return {
    UPDATE_OPERATOR: 1,
    GEO_FENCE_ENTRY_PICKUP: 2,
    GEO_FENCE_EXIT_PICKUP: 3,
    GEO_FENCE_ENTRY_DROP: 4,
    GEO_FENCE_EXIT_DROP: 5,
    HYEPERTRACK_SET_TRACKING_URL: 6,
  };
}

function getSuperadminFeature() {
  return {
    FEATURE_TRACK_UPDATE: 'trackUpdate',
    FEATURE_GEO_FENCE_ENTRY: 'geoFenceEntry',
    HYEPERTRACK_SET_TRACKING_URL: 'hyperTrackSetTrackingUrl',
    FEATURE_GEO_FENCE_ENTRY_EXIT: 'geoFenceEntryExit',
  };
}


module.exports = {
  getTrackingQueueNames,
  shipperUpdateType,
  getSuperadminFeature,
  getGenericJobTypes,
  getGenericReportJobTypes,
};
